module.exports = __webpack_public_path__ + "img/dashboard.66b90527.svg";